<template>
    <restaurant-list-section
        class="restaurants-carousel-section-module"
        :title="attributes.restaurantCarouselSection_title"
        :restaurants="restaurants"
        :show-navigation-buttons="attributes.restaurantsCarouselSection_show_navigation_buttons"
    />
</template>

<script>
    import RestaurantListSection from '../../../organisms/RestaurantListSection/RestaurantListSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'restaurants-carousel-section-module',

        components: { RestaurantListSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Get formatted restaurant data.
             *
             * @returns {Array}
             */
            restaurants() {
                return (this.attributes.restaurants || []).map((restaurant) => {
                    return {
                        title: restaurant.name,
                        image: formatMediaObject.call(this, restaurant.image),
                        address: restaurant.address,
                        to: restaurant.page?.uri || '',
                    };
                });
            },
        },
    };
</script>
